import validator from 'validator';

export const fixURL = (url) => {
  if (url.toLowerCase().includes('@')) {
    return url;
  }

  let _url = url;
  if (
    !url.toLowerCase().includes('http://') &&
    !url.toLowerCase().includes('https://') &&
    !url.toLowerCase().includes('viber://')
  ) {
    _url = `http://${url}`;
  }
  if (validator.isURL(_url, { allow_underscores: true })) {
    const parts = _url.split('/');
    const domain = [
      parts[0].toLowerCase(),
      parts[2].toLowerCase()
    ].join('//');
    const domainPath = parts.slice(3).join('/');
    return domain + '/' + domainPath;
  }
  return _url;
};

export const cutHTTP = url => {
  let _url = url.toLowerCase();

  if (_url.substring(_url.length - 1, _url.length) === '/') {
    _url = _url.substring(0, _url.length - 1);
  }
  if (_url.substring(0, 1) === '/') {
    _url = _url.substring(1, _url.length);
  }

  if (_url.includes('http://') || _url.includes('https://')) {
    _url = _url.replace(/^https?\:\/\//i, "");
  }
  return _url;
};
